module.exports = __webpack_public_path__ + "img/webworthy-4.ebe1db77.jpg";